import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import TechMarquee from './TechMarquee';
import { BrandIcon } from './icons';
import { STUDIO } from '../data/studio';
import { HOME_PATHS } from '../utils/navActive';
import { useLanguage } from '../i18n/LanguageContext';
import { cx } from '../utils/cx';
import mixins from '../styles/mixins.module.css';
import styles from './Footer.module.css';

const SOCIALS = [
  ['linkedin', 'LinkedIn'],
  ['medium', 'Medium'],
  ['github', 'GitHub'],
];

export default function Footer() {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const showTechStack = HOME_PATHS.includes(pathname);

  return (
    <footer className={styles.footer}>
      <div className={mixins.wrap}>
        {showTechStack && (
          <>
            <div className={styles.stackTitle}>{t('techStackTitle')}</div>
            <TechMarquee />
          </>
        )}
        <div className={styles.foot}>
          <div className={styles.footL}>
            <span>© {new Date().getFullYear()} OnyxUp</span>
            <a href={`mailto:${STUDIO.email}`} className={styles.mail}>
              {STUDIO.email}
            </a>
            <div className={cx(mixins.social, styles.social)}>
              {SOCIALS.map(([k, label]) => (
                <a key={k} href={STUDIO.social[k]} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
                  <BrandIcon name={k} />
                </a>
              ))}
              <a href={STUDIO.social.x} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" title="X (Twitter)">
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
          </div>
          <nav className={cx(styles.footNav)}>
            <Link to="/apps">{t('footerApps')}</Link>
            <Link to="/privacy">{t('footerPrivacy')}</Link>
            <Link to="/terms">{t('footerTerms')}</Link>
            <Link to="/contact">{t('footerContact')}</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
